import Vue from 'vue'

import i18n from '@/i18n'

// Короткие уведомления о результате операции: состояние одного общего v-snackbar,
// который рисует AppToast в App.vue. Он живёт вне router-view, поэтому
// уведомление, показанное перед переходом на другую страницу, не пропадает.
export const toastState = Vue.observable({
	visible: false,
	type: 'success',
	text: '',
	timeout: 4000,
})

const TIMEOUTS = {
	success: 4000,
	info: 4000,
	warning: 6000,
	error: 7000,
}

// Пока одно уведомление на экране, следующие ждут своей очереди
const queue = []

function isDuplicate(type, text) {
	const shown = toastState.visible && toastState.type === type && toastState.text === text
	return shown || queue.some((item) => item.type === type && item.text === text)
}

function display(item) {
	Object.assign(toastState, item, { visible: true })
}

// AppToast вызывает это, когда уведомление скрылось
export function showNextToast() {
	// за время паузы могли уже показать новое уведомление напрямую
	if (toastState.visible) return

	const next = queue.shift()
	if (next) display(next)
}

function show(type, text, options = {}) {
	if (!text) return
	text = String(text)
	if (isDuplicate(type, text)) return

	const item = { type, text, timeout: options.timeout || TIMEOUTS[type] }

	if (toastState.visible) queue.push(item)
	else display(item)
}

function firstMessage(value) {
	if (!value) return ''
	if (typeof value === 'string') return value
	if (Array.isArray(value)) return firstMessage(value[0])
	if (typeof value === 'object') return firstMessage(Object.values(value)[0])
	return ''
}

// Текст ошибки запроса: сообщение сервера, а если его нет — переданный запасной текст
export function errorText(error, fallback) {
	if (typeof error === 'string') return error

	const response = error?.response
	if (error && !response) return i18n.t('toast.network_error')
	if (response?.status >= 500) return i18n.t('system_message.500')

	const data = response?.data
	return (
		firstMessage(data?.message) ||
		firstMessage(data?.error_message) ||
		firstMessage(data?.error_messages) ||
		firstMessage(data?.errors) ||
		firstMessage(data?.error) ||
		fallback ||
		i18n.t('toast.error')
	)
}

export const toast = {
	success(text, options) {
		show('success', text, options)
	},
	error(text, options) {
		show('error', text, options)
	},
	warning(text, options) {
		show('warning', text, options)
	},
	info(text, options) {
		show('info', text, options)
	},
	// Ошибка запроса: текст берётся из ответа сервера, fallback — если сервер ничего не прислал
	apiError(error, fallback, options) {
		show('error', errorText(error, fallback), options)
	},
}

export default {
	install(VueInstance) {
		VueInstance.prototype.$toast = toast
	},
}
